"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertiseAdministrationApi = exports.AdvertiseAdministrationApiFactory = exports.AdvertiseAdministrationApiFp = exports.AdvertiseAdministrationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AdvertiseAdministrationApi - axios parameter creator
 * @export
 */
const AdvertiseAdministrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: UpdateAdvertise - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Reklam verisini günceller. Gönderilmiş bir imaj var ise IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.AdvertiseCover olmalıdır. Handler metodunda @CacheEvict(\"advertise\") kullanılmalıdır. Bu kısımda son reklam verilerinin üzerine güncelleme yapılarak yeni satıra son hali oluşturulur. Burada ne yapılacağını anlayamamanız durumunda lütfen sormaktan çekinmeyiniz.
         * @param {UpdateAdvertiseCommand} [updateAdvertiseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdvertise: (updateAdvertiseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/advertise_administration/update_advertise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAdvertiseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdvertiseAdministrationApiAxiosParamCreator = AdvertiseAdministrationApiAxiosParamCreator;
/**
 * AdvertiseAdministrationApi - functional programming interface
 * @export
 */
const AdvertiseAdministrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdvertiseAdministrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: UpdateAdvertise - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Reklam verisini günceller. Gönderilmiş bir imaj var ise IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.AdvertiseCover olmalıdır. Handler metodunda @CacheEvict(\"advertise\") kullanılmalıdır. Bu kısımda son reklam verilerinin üzerine güncelleme yapılarak yeni satıra son hali oluşturulur. Burada ne yapılacağını anlayamamanız durumunda lütfen sormaktan çekinmeyiniz.
         * @param {UpdateAdvertiseCommand} [updateAdvertiseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdvertise(updateAdvertiseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAdvertise(updateAdvertiseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdvertiseAdministrationApiFp = AdvertiseAdministrationApiFp;
/**
 * AdvertiseAdministrationApi - factory interface
 * @export
 */
const AdvertiseAdministrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdvertiseAdministrationApiFp)(configuration);
    return {
        /**
         * Operation Id: UpdateAdvertise - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Reklam verisini günceller. Gönderilmiş bir imaj var ise IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.AdvertiseCover olmalıdır. Handler metodunda @CacheEvict(\"advertise\") kullanılmalıdır. Bu kısımda son reklam verilerinin üzerine güncelleme yapılarak yeni satıra son hali oluşturulur. Burada ne yapılacağını anlayamamanız durumunda lütfen sormaktan çekinmeyiniz.
         * @param {UpdateAdvertiseCommand} [updateAdvertiseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdvertise(updateAdvertiseCommand, options) {
            return localVarFp.updateAdvertise(updateAdvertiseCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdvertiseAdministrationApiFactory = AdvertiseAdministrationApiFactory;
/**
 * AdvertiseAdministrationApi - object-oriented interface
 * @export
 * @class AdvertiseAdministrationApi
 * @extends {BaseAPI}
 */
class AdvertiseAdministrationApi extends base_1.BaseAPI {
    /**
     * Operation Id: UpdateAdvertise - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Reklam verisini günceller. Gönderilmiş bir imaj var ise IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.AdvertiseCover olmalıdır. Handler metodunda @CacheEvict(\"advertise\") kullanılmalıdır. Bu kısımda son reklam verilerinin üzerine güncelleme yapılarak yeni satıra son hali oluşturulur. Burada ne yapılacağını anlayamamanız durumunda lütfen sormaktan çekinmeyiniz.
     * @param {UpdateAdvertiseCommand} [updateAdvertiseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiseAdministrationApi
     */
    updateAdvertise(updateAdvertiseCommand, options) {
        return (0, exports.AdvertiseAdministrationApiFp)(this.configuration).updateAdvertise(updateAdvertiseCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdvertiseAdministrationApi = AdvertiseAdministrationApi;
